const graph = {
  "queryState": {
    "layerCatalogLoadFailed": "레이어 목록을 불러오지 못했습니다",
    "savedSectionListLoadFailed": "저장된 데이터를 불러오지 못했습니다",
    "exportListLoadFailed": "반출 파일 목록을 불러오지 못했습니다",
    "shootingDateListLoadFailed": "촬영일 목록을 불러오지 못했습니다",
  },
  "checkCrossSection": "단면 확인",
  "checkLongitudeSection": "종단면 확인",
  "height": "고도",
  "distance": "거리",
  "line": "선형",
  "alignment": "선형",
  "stratum": "지층",
  "designHeight": "설계도",
  "check": "확인",
  "longitudeSection": "종단면",
  "specificSection": "특정",
  "crossSection": "횡단면",
  "crossSectionList": "횡단면 리스트",
  "crossSectionGraph": "횡단면 그래프",
  "perpendicularInterval": "횡단 간격",
  "pointInterval": "점 간격",
  "pointSetting": "지점 설정",
  "detailSetting": "세밀화 설정",
  "startPoint": "시작점",
  "endPoint": "끝점",
  "section": "구간",
  "sectionStartPoint": "시점",
  "sectionEndPoint": "종점",
  "original": "원본 보기",
  "detail": "세밀화 보기",
  "startPointError": "시작 측점은 기본 값보다 작을 수 없습니다.",
  "enterBranch": "지점을 입력해주세요.",
  "validate": {
    "dxfSaveFileDownloadError": "파일 다운로드 중 오류가 발생했습니다. 다시 시도해주세요.",
    "dxfSaveFileGenerateNotice": "파일 생성 요청되었습니다. 보통 10분 이내 완료됩니다. 잠시 후에 확인 해주세요.",
    "dxfSaveFileGenerateError": "파일 생성에 실패했습니다. 잠시 후 다시 시도해주세요.",
    "noSavedData": "저장된 데이터가 없습니다.",
    "failDeleteData": "데이터를 삭제하는데 실패했습니다. 다시 시도해주세요.",
    "savePerpendicular": "횡단면이 저장되었습니다.",
    "deletePerpendicular": "횡단면이 삭제되었습니다.",
    "existingCrossSection": "이미 저장된 횡단면이 있습니다. 삭제 후 다시 시도해주세요.",
    "leftRightSpacing": "점 간격보다 좌,우 간격이 커야 합니다.",
    "pointIntervalMin": "점 간격은 {{min}}m 이상이어야 합니다.",
    "endPointInfo": "종점을 입력하지 않거나 종점이 선형 길이보다 길다면 전체 단면을 볼 수 있습니다.",
    "lngStartPoint": "종단면의 시작측점은 TEXT 파일에만 반영됩니다.",
    "startStepError": "시점은 기본 값보다 작을 수 없습니다.",
    "endStepError": "종점은 시점보다 작을 수 없습니다.",
    "sameStepError": "시점과 종점은 같을 수 없습니다.",
    "maxStratumFilesSelected": "파일은 최대 세 개까지만 선택할 수 있습니다.",
    "maxStep": "간격은 100 이하이어야 합니다.",
    "increment": "간격은 5의 배수이어야 합니다.",
    "equal": "점 간격은 횡단 간격보다 같거나 작아야 합니다.",
    "setPoint": "시작점과 끝점을 설정해주세요",
    "pointAdditionError": "추가 지점은 시작측점보다 작을 수 없습니다.",
    "pointAdded": "특정 횡단면이 추가되었습니다.",
    "pointAdditionFailed": "특정 횡단면 추가에 실패했습니다. 잠시후 다시 시도해주세요.",
    "pointAdditionTargetFailed": "이미 해당 거리에 횡단면이 있습니다. 입력한 거리를 확인해주세요.",
    "distanceExceedsSegmentLength": "입력한 거리가 선분의 길이를 초과했습니다.",
    "crossSectionDeletionFailed": "횡단면 삭제에 실패했습니다. 잠시후 다시 시도해주세요."
  },
  "perpendicularList": "저장된 횡단면",
  "selectPerpendicular": "횡단면을 선택해주세요",
  "perpendicularDeleted": "횡단면이 삭제되었습니다.",
  "deleteSavedTitle": "저장된 횡단면 삭제",
  "deleteSavedSectionMessage": "{{name}} 구간을 삭제할까요?",
  "deleteSavedStationMessage": "{{name}} 측점을 삭제할까요?",
  "exportSection": "반출",
  "enterDistance": "거리를 입력해 주세요.",
  "enterDistanceInRange": "범위에서 입력해 주세요.",
  "perpendicularDataNotFound": "해당 거리의 횡단면 데이터를 찾을 수 없습니다.",
  "specialPerpendicularAdded": "특별 횡단면이 추가되었습니다.",
  "perpendicularAlreadyExists": "이미 동일한 위치에 횡단면이 존재합니다.",
  "specialPerpendicularAddFailed": "특별 횡단면 추가에 실패했습니다.",
  "perpendicularGraph": "횡단면 그래프",
  "addSpecialPerpendicular": "특별 횡단면 추가",
  "noSavedData": "저장된 데이터가 없습니다.",
  "loading": "불러오는 중입니다",
  "delete": "삭제",
  "cancel": "취소",
  "edit": "편집",
  "confirm": "확인",
  "perpendicularSelectionTree": "횡단면 선택 트리",
  "loadingInProgress": "로딩 중...",
  "createFile": "파일을 생성해주세요.",
  "exportPerpendicularData": "횡단면 데이터 내보내기",
  "invalidFileFormat": "유효하지 않은 파일 형식입니다.",
  "fileReadFailed": "파일을 읽는 데 실패했습니다.",
  "noSectionSelected": "선택된 섹션이 없습니다.",
  "selectFileToExport": "내보낼 파일을 선택해주세요.",
  "noExportableFiles": "내보낼 수 있는 파일이 없습니다.",
  "csvDownloaded": "CSV 파일이 다운로드되었습니다.",
  "csvDownloadFailed": "CSV 다운로드에 실패했습니다.",
  "dxfDownloaded": "DXF 파일이 다운로드되었습니다.",
  "dxfDownloadFailed": "DXF 다운로드에 실패했습니다.",
  "earthworkTableFeatureComingSoon": "토공 집계표 다운로드 기능은 준비 중입니다.",
  "selectFileToDelete": "삭제할 파일을 선택해주세요.",
  "fileDeleted": "파일이 삭제되었습니다.",
  "fileNotFound": "파일을 찾을 수 없습니다.",
  "fileDeletionFailed": "파일 삭제에 실패했습니다.",
  "selectFileToRename": "이름을 변경할 파일을 선택해주세요.",
  "noFileNameChanged": "변경된 파일명이 없습니다.",
  "fileRenamed": "파일명이 변경되었습니다.",
  "duplicateFileName": "이미 동일한 파일명이 존재합니다.",
  "fileRenameFailed": "파일명 변경에 실패했습니다.",
  "fileNameSlashNotAllowed": "파일 이름에 / 는 들어갈 수 없습니다.",
  "fileInfoNotFound": "파일 정보를 찾을 수 없습니다.",
  "fileUpdateStarted": "파일 업데이트가 시작되었습니다.",
  "perpendicularDataNotFoundForUpdate": "횡단면 데이터를 찾을 수 없습니다.",
  "fileUpdateFailed": "파일 업데이트에 실패했습니다.",
  "fileName": "파일 이름",
  "includedFiles": "포함 파일",
  "updateDate": "업데이트 날짜",
  "update": "업데이트",
  "done": "완료",
  "creating": "생성중",
  "rename": "이름 수정",
  "download": "다운로드",
  "txtDownloadHelp": "RP, BIMNODE 프로그램에서 횡단을 그릴 수 있습니다.",
  "earthworkTable": "토공 집계표",
  "earthworkTableRequirement": "토공 집계표는 지반고와 계획고가 모두 있어야 생성 가능합니다",
  "earthworkTableNoData": "집계표 데이터가 없습니다.",
  "earthworkTableDownloaded": "토공 집계표가 다운로드되었습니다.",
  "earthworkTableDownloadFailed": "토공 집계표 다운로드에 실패했습니다.",
  "earthworkStationQuantity": "토공 횡단수량",
  "earthworkStationQuantityRequirement": "토공 횡단수량은 지반고와 계획고가 모두 있어야 생성 가능합니다",
  "earthworkStationQuantityNoData": "스테이션별 흙쌓기/흙깎기 데이터가 없습니다.",
  "earthworkStationQuantityDownloaded": "토공 횡단수량이 다운로드되었습니다.",
  "earthworkStationQuantityDownloadFailed": "토공 횡단수량 다운로드에 실패했습니다.",
  "select": "선택",
  "itemsSelected": "개 선택됨",
  "multipleSelectable": "여러 개 선택 가능",
  "singleSelectable": "하나만 선택 가능",
  "selectStandardTimeSeries": "기준 시계열 선택",
  "standard": "기준",
  "elevationProfile": "고도 프로파일",
  "partialMode": "부분 모드",
  "resetView": "뷰 리셋",
  "crossSectionElevationProfile": "횡단면 고도 프로파일",
  "crossSectionNumber": "번 횡단면",
  "station": "측점",
  "quantityTable": "수량표",
  "quantityTableTooltip": "설계도에 계획고와 원지반고가 모두 있어야\n수량표를 확인할 수 있습니다.",
  "crossSectionQuantityTable": "횡단 수량표",
  "baseDate": "기준",
  "excelDownload": "엑셀 다운로드",
  "noQuantityData": "해당 위치에 계획고 또는 원지반고가 없어 수량표를 계산할 수 없습니다.",
  "planned": "계획",
  "progressed": "진행",
  "currentHeight": "현황고",
  "fill": "쌓기",
  "cut": "깎기",
  "fillSubgrade": "노상",
  "fillRoadbed": "노체",
  "fillUncompacted": "비다짐",
  "fillRockFill": "암쌓기",
  "cutSoilCut": "토사",
  "cutRipping": "리핑",
  "cutBlasting": "발파",
  "earthworkSection": "구간",
  "earthworkFillGroup": "흙쌓기",
  "earthworkCutGroup": "땅깎기",
  "earthworkSubtotal": "소계",
  "earthworkColType": "구분",
  "earthworkColMaterial": "성상 구분",
  "earthworkColPlannedQty": "계획 수량",
  "earthworkColRemainingQty": "잔여토공량",
  "earthworkColDailyTotal": "일자별 누계",
  "earthworkKeyDesignHeight": "계획고",
  "earthworkKeyGroundHeight": "지반고",
  "timeSeries": "현황",
  "maxFourSelectable": "*최대 4개 선택 가능",
  "complete": "완료",
  "layer": "레이어",
  "planDropdown": "계획",
  "stratumDropdown": "지층",
  "legendGround": "원지반고",
  "legendDesign": "계획고",
  "stratumMaxThree": "지층 (최대 3개 선택 가능)",
  "groundMaxOne": "원지반고 (1개 선택 가능)",
  "designMaxOne": "계획고 (1개 선택 가능)",
  "noAvailableLayers": "사용 가능한 레이어가 없습니다",
  "earthworkSummaryTable": "전체 토공 집계표",
  "downloadOverallSummaryTable": "전체 집계표 다운로드",
  "summaryTableTooltip": "횡단면 파일을 생성하면 전체 집계표를 확인 할 수 있습니다."
} as const;

export default graph;
